export const LOGIN_REQUEST = "LOGIN";
export const LOGOUT = "LOGOUT"; //log
